export const SEGMENT_TYPE_COMMENT = 'COMMENT';
export const SEGMENT_TYPE_TAG = 'TAG';
export const SEGMENT_TYPE_GENERIC = 'GENERIC';

export const SEGMENT_FORM_TYPE_SUBCLIP = 'SUBCLIP';
